module.exports = __webpack_public_path__ + "static/media/sobhaIcon.a0e44e12.svg";